export const environment = {
  production: false,
  apiUrl: 'https://gateway.stg.cloud.pje.jus.br/banco-prompts',
  duracaoTokenEmMinutos: 60 * 12,
  paths: {
    base: 'https://promptus.stg.pdpj.jus.br'
  },
  keycloak: {
    issuer: 'https://sso.stg.cloud.pje.jus.br/auth',
    realm: 'pje',
    clientId: 'banco-prompts-frontend'
  },
  excludedUrls: [],
  version: 'f95c8512'
};
